<template>
  <a-table
    sticky
    :dataSource="tableData"
    :columns="column"
    :bordered="false"
    :scroll="tableData.length > 0 ? scroll : none"
    :loading="tableLoading"
    :pagination="false"
    :expandable="expandable"
    :row-selection="rowSelection"
    @select="onSelect"
    @selectAll="onSelectAll"
    :rowKey="rowKey"
    @change="onHChange"
    @expand="onExpand"
    :style="{ height: height }"
  >
    <template v-slot:headerCell="{ column }">
      <slot name="headerCell" :column="column"> </slot>
    </template>
    <template
      v-for="(item, index) in slots"
      :key="index"
      #[item.slots.customRender]="row"
    >
      <div v-if="item.slots">
        <slot :name="item.slots.customRender" :scope="row"></slot>
      </div>
    </template>
    <template #bodyCell="{ column, record }">
      <!-- 时间 -->
      <slot v-if="column.isTime">{{
        record[column.key] ? ts_to_time_computed(record[column.key]) : "-"
      }}</slot>
      <slot v-else-if="column.isAllTime">{{
        record[column.key]
          ? ts_to_time_computed_all(record[column.key] / 1000)
          : "-"
      }}</slot>
      <!-- 单位为分 -->
      <slot v-else-if="column.isMinute">
        {{ column.symbol
        }}{{ record && record[column.key] ? record[column.key] / 100 : 0 }}
      </slot>

      <slot :name="column.key" :record="record"> </slot>
    </template>

    <template v-if="isEexpandedRowRender" #expandedRowRender="{ record }">
      <slot name="expandedRowRender" :record="record"></slot>
    </template>
  </a-table>
</template>
<script>
import { ref, watch, computed, onMounted } from "vue";
import { formatDate } from "@/utils/utils";

export default {
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    scroll: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "auto",
    },
    isEexpandedRowRender: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Object,
      default: () => ({}),
    },
    rowSelection: {
      type: Object,
      default: () => null,
    },
    rowKey: {
      type: [String, Function],
      default: "key",
    },
  },
  setup(props, context) {
    const column = ref(props.columns);
    const tableData = ref(props.dataSource);
    const tableLoading = ref(props.loading);
    const rowSelection = ref(props.rowSelection);

    watch(
      () => props.columns,
      (val) => {
        column.value = val;
      }
    );
    watch(
      () => props.dataSource,
      (val) => {
        tableData.value = val;
      }
    );
    watch(
      () => props.loading,
      (val) => {
        tableLoading.value = val;
      }
    );
    watch(
      () => props.rowSelection,
      (val) => {
        rowSelection.value = val;
      }
    );

    onMounted(() => {
      props.columns.filter((vals) => {
        return vals.slots;
      });
    });

    const slots = computed(() => {
      return props.columns.filter((val) => {
        return val.slots;
      });
    });
    const ts_to_time_computed = computed(() => {
      return (val) => {
        return formatDate(val * 1000, "hh:mm");
      };
    });
    const ts_to_time_computed_all = computed(() => {
      return (val) => {
        return formatDate(val * 1000);
      };
    });
    const onHChange = (pagination, filters, sorter, extra) => {
      context.emit("myChange", {
        pagination: pagination,
        filters: filters,
        sorter: sorter,
        extra: extra,
      });
    };
    const onExpand = (expanded, record) => {
      context.emit("expand", { expanded, record });
    };

    // 行选择事件处理
    const onSelect = (record, selected, selectedRows, nativeEvent) => {
      context.emit("select", { record, selected, selectedRows, nativeEvent });
    };

    const onSelectAll = (selected, selectedRows, changeRows) => {
      context.emit("selectAll", { selected, selectedRows, changeRows });
    };

    return {
      column,
      tableData,
      slots,
      onHChange,
      onExpand,
      onSelect,
      onSelectAll,
      tableLoading,
      ts_to_time_computed,
      ts_to_time_computed_all,
      rowKey: props.rowKey,
      rowSelection,
    };
  },
};
</script>

<style></style>
